import React, { useMemo } from 'react';
import {
  exact, arrayOf, string, number, bool, func,
} from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { Flex, Button } from '@atoms';
import { OrdoItem } from '@molecules';

const DraggableItems = ({
  items, isDraggable, canBeAdded, onItemAdd, onItemClick, isDataTheSame, onItemRemove,
}) => {
  const ConditionalDraggableWrapper = ({ condition, wrapper, children }) => (
    condition ? wrapper(children) : children
  );

  const memoizedItems = useMemo(() => items.map(({ name, id }, index) => (
    <ConditionalDraggableWrapper
      condition={isDraggable}
      key={id}
      wrapper={children => (
        <Draggable key={id} draggableId={id.toString()} index={index}>
          {({ innerRef, dragHandleProps, draggableProps }) => (
            <Flex
              ref={innerRef}
              {...draggableProps}
              {...dragHandleProps}
            >
              {children}
            </Flex>
          )}
        </Draggable>
      )}
    >
      <OrdoItem
        id={id}
        onItemClick={onItemClick}
        name={name}
        onItemRemove={onItemRemove}
      />
    </ConditionalDraggableWrapper>
  )), [items, isDataTheSame]);

  return (
    <>
      {canBeAdded && (
        <Flex selfCenter>
          <Button.Circular
            secondary
            diameter={38}
            padding="sm"
            onClick={onItemAdd}
            marginBottom="sm"
          >
            +
          </Button.Circular>
        </Flex>
      )}
      {memoizedItems}
    </>
  );
};

DraggableItems.defaultProps = {
  isDataTheSame: true,
  onItemClick: () => {},
  isDraggable: true,
  canBeAdded: false,
  onItemAdd: () => {},
  onItemRemove: null,
};

DraggableItems.propTypes = {
  isDataTheSame: bool,
  onItemClick: func,
  onItemAdd: func,
  onItemRemove: func,
  canBeAdded: bool,
  isDraggable: bool,
  items: arrayOf(exact({
    name: string,
    id: number,
  })).isRequired,
};

export default DraggableItems;
